export default __webpack_public_path__ + "static/media/dalzell.770eb3d9.jpg";